	import React, { useState, useLayoutEffect, useRef, useEffect } from 'react'
  import { navigate } from "gatsby"
	import PropTypes from 'prop-types';
	import { css } from '@emotion/react';
	import { Section, breakpoints } from '~styles/global'
	import Select from '~components/Select'
	import Button from '~components/Button'
	import Image from '~components/Image'
  import { Truck } from '../Svg';
  import RichText from '~components/RichText'
  import { useLocation } from "@reach/router"
  import { useQueryParams, StringParam } from 'use-query-params'
  import { useCart, useSiteState } from '~context/siteContext'
	import Video from '~components/Video'

	const ProductComponent = ({ image, name, maker, shortDesc, price, productOptions, quantity, id, variants, className, content, slug, video}) => {
	
	const { mobile, tablet } = breakpoints
  
  const [currentOption, setCurrentOption] = useState()
  const [currentVariant, setCurrentVariant] = useState({})
  const selectRef = useRef()
  const location = useLocation()
  const { addItem } = useCart()

  const [params, setParams] = useQueryParams({v: StringParam})

  function navigateToVariant(variant){
    setCurrentVariant(variant)
    const value = variant?.options[0]?.value
		if(value) selectRef.current.value = value
    navigate(location.pathname + `?v=${variant.content.shopify.variantId}`,
      {
        state: {
          disableScrollUpdate: true,
        },
        replace: true
      }
    )
  }

  const findVariantByValue = value => {
    const result = variants.find(v => v.options[0].value === value)
    return result
  }

  const findVariantById = id => {
    const result = variants.find(v => v.content.shopify.variantId.toString() === id)
    return result
  }

  function handleVariantChange(e){
    e.preventDefault()
    setCurrentOption(e.target.value)
  }

  useEffect(() => {
    if(currentOption){
      const newVariant = findVariantByValue(currentOption)
      navigateToVariant(newVariant)
    }
  }, [currentOption])

  // Set the variant to on load
  useLayoutEffect(() => {
    if(!params.v){
      navigateToVariant(variants[0])
    } else {
      const newVariant = findVariantById(params.v)
			if(newVariant){
				navigateToVariant(newVariant)
			}
      
    }
  }, [params.v])

  const variantObject = {
    variantId: currentVariant.content?.shopify?.variantId,
    title: currentVariant.content?.shopify?.title,
    price: currentVariant.content?.shopify?.price,
    variant: currentVariant.content?.shopify?.variantTitle, 
    slug: slug, 
    qty: 1,
		maxQty: currentVariant.content?.shopify?.inventoryQuantity,
    image: currentVariant.content?.image?.asset?.id,
  }

  // Add to cart
  const add = () => {
    addItem(variantObject)
  }

	return (
		<Section
      className={className} 
			css={css`
				background-color: var(--white);
				padding: 8rem 0 10rem;
				${mobile} {
					padding: 2.5rem 0 8rem;
				}
			`}
		>
				<Video src={currentVariant?.content?.video?.asset?.url} aspectRatio={1} css={css`
						border-radius: var(--standard);
						overflow: hidden;
            grid-column: span 6;
            height: auto;
						${mobile} {
							grid-column: span 12;
							margin-bottom: 30px;
						}
						video{
							width: 100%;
						}
				`}/>
				<div css={css`
					grid-column: span 6;
					${mobile} {
						grid-column: span 12;
					}
				`}>
						<h4 css={css`margin-bottom: 0.7em;`}>{maker}</h4>
						<h1 className="serif" css={css`margin-bottom: 0.2em;`}>{name}</h1>
						<div css={css`
								height: 40px;
								background-color: var(--lightGrey);
								margin-bottom: 1em;
								border-radius: 100px;
								align-items: center;
								display: inline-grid;
								padding: 0px 1.5rem;
						`}>
							<div css={css`
								margin-top: 3px;
							`}>${currentVariant.content?.shopify?.price}</div>
						</div>
						<div css={css`
							margin-bottom: 1em;
							max-width: 500px;
						`}>
							<RichText content={shortDesc}/>
						</div>
						<div css={css`
								display: grid;
								grid-template-columns: minmax(min-content, 206px) minmax(min-content, 206px);
								grid-column-gap: 15px;
								margin-bottom: 1.3em;
								align-items: center;
								
								${tablet} {
									grid-template-columns: 1fr;
									grid-row-gap: 15px;
								}
						`}>
								{productOptions?.length > 0 && 
								<div css={css`
								display: grid;
								grid-row-gap: 15px;
								display: ${productOptions[0].values[0] === 'Default Title' ? 'none' : 'block'};
							`}>
								<Select 
										onChange={e => handleVariantChange(e)}
                    ref={selectRef}
										key={productOptions[0].name}
                    // initialValue={initalSelectValue}
										css={css`
											width: 100%;
									`}>
									{productOptions[0].values?.map(option => (
											<option 
												key={productOptions[0].name + ' ' + option}
												value={option}
											>
												{option}
											</option>
									))}
									</Select>
								</div>
								}
								{currentVariant.content?.shopify?.inventoryQuantity > 0 &&
									<Button 
									onClick={() => add()}
									css={css`
										min-width: auto; 
										max-height: 42px;
								`}>
									Add To Cart
									</Button>
								}
								{currentVariant.content?.shopify?.inventoryQuantity === 0 &&
									<h4>Sold out</h4>
								}
                {/* {currentVariant.content?.shopify?.inventoryQuantity > 0 ? 'Add To Cart' : 'Sold Out'}</Button> */}
						</div>
						<div css={css`
								height: 40px;
								background-color: var(--lightGrey);
								margin-bottom: 2rem;
								border-radius: 8px;
								align-items: center;
								display: inline-grid;
								grid-template-columns: min-content 1fr;
								padding: 0px 1.5rem;
								column-gap: 12px;
						`}>
							<Truck css={css`
								width: 22px;
								height: 16px;
							`}/>
							<span className="h4" css={css`
								margin-top: 0.5rem;
							`}>FREE SHIPPING ON AUS ORDERS OVER $100</span>
						</div>
				</div>
		</Section>
	)
	}

	ProductComponent.propTypes = {
		name: PropTypes.string,
		maker: PropTypes.string,
		shortDesc: PropTypes.array,
		price: PropTypes.string, 
		productOptions: PropTypes.array,
		quantity: PropTypes.number, 
    id: PropTypes.number, 
    image: PropTypes.object, 
	}

	// ProductComponent.defaultProps = {
	// 	name: 'Product Name',
	// 	maker: 'Maker',
	// 	shortDesc: 'A candle is phasellus rhoncus et tellus in euismod. Phasellus rhoncus et tellus in euismod.',
	// 	price: 59.95, 
	// 	productOptions: [
	// 		{
	// 		  name: 'color',
	// 		  options: [
	// 			{
	// 			  name: 'Purple',
	// 			  value: 'purple'
	// 			},
	// 		  ]
	// 		},
	// 		{
	// 		  name: 'size',
	// 		  options: [
	// 			{
	// 			  value: 's',
	// 			  name: 'small'
	// 			},
	// 			{
	// 				value: 'm',
	// 				name: 'medium'
	// 			},
	// 		  ]
	// 		},
	// 	],
	// 	quantity: 1, 
	// 	id: 'testId', 
	// }

	export default ProductComponent
